import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { PROJECT_REASONS } from '../common/real-estate-form-options';

@Component({
  selector: 'app-real-estate-project-justification',
  templateUrl: './real-estate-project-justification.component.html',
  styleUrls: ['./real-estate-project-justification.component.scss'],
  standalone: false,
})
export class RealEstateProjectJustificationComponent implements OnInit {
  @Input() realEstateJustificationForm: FormGroup;
  @Input() reviewMode: boolean = false;

  projectReasons = PROJECT_REASONS;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    // Handle reviewMode changes
    if (this.realEstateJustificationForm && changes['reviewMode']) {
      if (this.reviewMode) {
        this.realEstateJustificationForm.disable();
      } else {
        this.realEstateJustificationForm.enable();
      }
    }
  }

  projectJustificationLength(): number {
    const projectJustification =
      this.realEstateJustificationForm.controls['projectJustification'].value;
    return projectJustification ? projectJustification.length : 0;
  }

  get projectReasonArray(): FormArray {
    return this.realEstateJustificationForm.get('projectReason') as FormArray;
  }

  onCheckboxChange(event: any, reasonValue: string) {
    const reasonArray = this.projectReasonArray;

    if (event.checked) {
      // Add to array if checked
      reasonArray.push(this.fb.control(reasonValue));
    } else {
      // Remove from array if unchecked
      const index = reasonArray.controls.findIndex((control) => control.value === reasonValue);
      if (index !== -1) {
        reasonArray.removeAt(index);
      }
    }
  }
}
